export default __webpack_public_path__ + "static/media/repave.cd8f601f.jpg";